"use strict";
class AlarmListSubscriber {
}
exports.AlarmListSubscriber = AlarmListSubscriber;
